import get from 'lodash-es/get'
import * as React from 'react'

import { config } from '../../../../common/config'
import { IItemCard } from '../interface'

import * as styles from './itemCardSmallPreview.module.css'

const ItemCardSmallPreview = (props: IItemCard) => {
  const defaultUserIcon = `${config.assets.PUBLIC_PATH}/images/default-user.jpg`

  return (
    <a
      href={`${props.item.url}?s_rank=${props.rank}`}
      onClick={props.onItemLinkClick}
      className={styles.link}
    >
      <img
        className={styles.root}
        src={
          get(props, 'item.previews.icon_with_audio_preview.icon_url') ||
          defaultUserIcon
        }
        alt={get(props, 'item.name')}
        width="22"
        height="22"
      />
    </a>
  )
}

export default ItemCardSmallPreview
